/* Spinder Design — Hero: zoom-in bij verschijnen + parallax bij scroll.
   Respecteert prefers-reduced-motion (dan geen beweging). */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    var motion = root.getAttribute('data-motion');

    // Reduced motion: pauzeer eventuele video en doe niets met beweging.
    if (reduce || motion === 'none' || !motion) {
      var v0 = root.querySelector('[data-hero-video]');
      if (reduce && v0 && typeof v0.pause === 'function') {
        try { v0.pause(); } catch (e) { /* negeer */ }
      }
      return;
    }

    if (motion === 'zoom') {
      // Trigger de CSS-transition zodra de hero in beeld komt.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('spinder-hero--in');
              io.unobserve(root);
            }
          });
        }, { threshold: 0.15 });
        io.observe(root);
      } else {
        root.classList.add('spinder-hero--in');
      }
      return;
    }

    if (motion === 'parallax') {
      var media = root.querySelector('[data-hero-media]');
      if (!media) return;
      var ticking = false;

      var update = function () {
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        // Alleen rekenen wanneer (deels) in beeld.
        if (rect.bottom < 0 || rect.top > vh) { ticking = false; return; }
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // ~ -1..1
        var shift = Math.max(-1, Math.min(1, progress)) * -40; // px
        root.style.setProperty('--spinder-parallax', shift.toFixed(1) + 'px');
        ticking = false;
      };

      var onScroll = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }

  function init() {
    var heroes = document.querySelectorAll('.spinder-hero');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Opnieuw initialiseren wanneer de sectie in de theme editor wordt geladen.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.spinder-hero');
    if (root) initHero(root);
  });
})();
